// extracted by mini-css-extract-plugin
module.exports = {"Root":"test_questions_Root__3st0j","SubmitButton":"test_questions_SubmitButton__2V2pr"};